import { modifyState } from '~src/state';
import { toggleEditorSidebar, hideSidebarTab } from '~src/sidebarLegacy';
import { getActiveMagicFrameActive } from '~core/magicFrame';

export const handleMagicFrameBackgroundSelection = async (url) => {
  modifyState('magicFrameSelectBackgroundPhotoActive', false);
  hideSidebarTab('manifesti');
  toggleEditorSidebar();
  const magicFrame = getActiveMagicFrameActive();
  if (!magicFrame) {
    return;
  }
  await magicFrame.updateBackground(url);
  window.canvas.renderAll();
};
